"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentryReporter = void 0;
const Sentry = __importStar(require("@sentry/react"));
const tracing_1 = require("@sentry/tracing");
const __1 = require("..");
const react_1 = require("@sentry/react");
function getSentrySeverity(level) {
    switch (level) {
        case __1.LogLevel.Error:
            return react_1.Severity.Error;
        case __1.LogLevel.Warn:
            return react_1.Severity.Warning;
        case __1.LogLevel.Info:
            return react_1.Severity.Info;
        case __1.LogLevel.Debug:
        default:
            return react_1.Severity.Debug;
    }
}
function sentryReporter(info, config) {
    var _a, _b;
    Sentry.init({
        dsn: config.dsn,
        tunnel: config.proxyUrl,
        integrations: [new tracing_1.Integrations.BrowserTracing()],
        allowUrls: config.allowUrls,
        environment: info.environment,
        release: (_a = config.release) !== null && _a !== void 0 ? _a : info.version,
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        tracesSampleRate: (_b = config.sampleRate) !== null && _b !== void 0 ? _b : 1.0,
    });
    const reporter = {
        trackEvent: function (event) {
            Sentry.captureEvent({
                level: event.level ? getSentrySeverity(event.level) : undefined,
                message: event.message,
                extra: {
                    ...event.metadata,
                    ...event.metrics,
                },
                tags: event.tags,
            });
        },
        addBreadcrumb: function (breadcrumb) {
            Sentry.addBreadcrumb({
                category: breadcrumb.category,
                message: breadcrumb.message,
                data: breadcrumb.metadata,
            });
        },
        addMetadata: function (metadata) {
            Sentry.setExtras(metadata);
        },
        setUser: function (user) {
            var _a;
            Sentry.setUser(user
                ? {
                    id: user.id,
                    email: user.email,
                    name: (_a = user.name) !== null && _a !== void 0 ? _a : user.email,
                    username: user.username,
                }
                : null);
        },
        setRouteName: function (routeName) {
            Sentry.setTag('routeName', routeName);
        },
        setPageName: function (pageName) {
            Sentry.setTag('pageName', pageName);
        },
        reportError: function (error, metadata) {
            Sentry.captureException(error, {
                extra: metadata,
            });
        },
        recordSession: function () { },
        recordSessionStop: function () { },
    };
    return reporter;
}
exports.sentryReporter = sentryReporter;
//# sourceMappingURL=sentryReporter.js.map